"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/login/slice");
const actions_1 = __importDefault(require("../../../app-reduxs/loginFirebase/actions"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const EyeLogin_1 = __importDefault(require("../../../assets/icons/EyeLogin"));
const EyeSlashLogin_1 = __importDefault(require("../../../assets/icons/EyeSlashLogin"));
const HelpLogin_1 = __importDefault(require("../../../assets/icons/HelpLogin"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalExplain_1 = __importDefault(require("../../../components/modal/ModalExplain"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importStar(require("../../../constants/constants"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Auth_1 = __importDefault(require("../../../networking/apis/Auth"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const CustomInput = (props) => {
    const { label, placeholder, errorText, onChangeText } = props;
    const [isSecure, setSecure] = (0, react_1.useState)(true);
    const [value, setValue] = (0, react_1.useState)('');
    return (react_1.default.createElement(InputField_1.default, { maxLength: 50, style: [styles_1.default.input, { marginTop: (0, scale_1.scale)(20) }], placeholder: placeholder, placeholderTextColor: "#C8C8C8", label: label, secureText: isSecure, value: value, onChangeText: (text) => {
            const val = text?.trim();
            setValue(val);
            onChangeText(val);
        }, errorText: errorText, rightIcon: !isSecure ? (react_1.default.createElement(EyeSlashLogin_1.default, { style: styles_1.default.iconInputLogin })) : (react_1.default.createElement(EyeLogin_1.default, { style: styles_1.default.iconInputLogin })), onRightIconPress: () => setSecure(!isSecure) }));
};
const RegisterScreen = (props) => {
    const isExist = !!(props?.route?.params?.isExist || 0);
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [email, setEmail] = (0, react_1.useState)('');
    const [visibleEmail, setVisibleEmail] = (0, react_1.useState)(false);
    const [checkRegister, setCheckRegister] = (0, react_1.useState)(isExist);
    const [errorTexts, setErrorTexts] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refPassword = (0, react_1.useRef)("");
    const refConfirmPassword = (0, react_1.useRef)("");
    (0, react_1.useEffect)(() => {
        (async () => {
            const _email = await AsyncStorage_1.default.get(constants_1.default.AUTH_EMAIL);
            if (!!_email) {
                setEmail(_email);
            }
        })();
        return () => {
            AsyncStorage_1.default.remove(constants_1.default.AUTH_EMAIL);
        };
    }, []);
    const getUserProfile = () => {
        User_1.default.retrieveUser()
            .then((response) => {
            dispatch((0, slice_2.setProfileAction)(response.data.data));
        })
            .catch(() => { });
    };
    const validate = () => {
        let newErrors = ['', ''];
        react_native_1.Keyboard.dismiss();
        if (!refPassword.current) {
            newErrors[0] = "パスワードは必須項目です。";
        }
        else if (!constants_1.REGEX_PASSWORD.test(refPassword.current)) {
            newErrors[0] = "パスワードには、有効なパスワードを指定してください";
            if (refPassword.current == refConfirmPassword.current) {
                newErrors[1] = "パスワードには、有効なパスワードを指定してください";
            }
        }
        if (!refConfirmPassword.current) {
            newErrors[1] = "パスワード（確認用）パスワードは必須項目です。";
        }
        if (refPassword.current != refConfirmPassword.current) {
            newErrors[0] = "パスワードとパスワード（確認用）が一致しません";
            newErrors[1] = "パスワードとパスワード（確認用）が一致しません";
        }
        if (newErrors.some(item => !!item)) {
            setErrorTexts(newErrors);
        }
        else {
            setLoading(true);
            Auth_1.default.signUpWithFujisan(email, refPassword.current)
                .then(async (response) => {
                const { token, refresh_token } = response.data;
                setCheckRegister(true);
                dispatch(slice_1.default.actions.showToast("アカウントを作成しました"));
                await AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, token);
                await AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, refresh_token);
                await AsyncStorage_1.default.set(constants_1.default.IS_COMPLETED_TUTORIAL, 0);
                await AsyncStorage_1.default.remove(constants_1.default.AUTH_EMAIL);
                dispatch((0, slice_2.saveAccessTokenAction)(token));
                dispatch(actions_1.default.loginFirebaseStartAction());
                getUserProfile();
            })
                .catch(err => {
                if (err?.response?.data?.error?.message?.password?.[0]) {
                    setErrorTexts([err.response.data.error.message.password[0], '']);
                }
                else if (err?.response?.data?.error?.message) {
                    react_native_1.Platform.OS === 'web' ?
                        alert(err.response.data.error.message)
                        :
                            react_native_1.Alert.alert(err.response.data.error.message);
                }
            })
                .finally(() => setLoading(false));
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "新規登録", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: !checkRegister && (react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        fontWeight: "300",
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB")), onLeftPress: () => {
                    !checkRegister && (0, rootNavigation_1.goBack)();
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, { style: { flex: 1 } },
                react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: { paddingBottom: (0, scale_1.scale)(60) }, showsVerticalScrollIndicator: false },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.loginForm },
                        checkRegister ? (react_1.default.createElement(react_native_1.View, { style: {
                                alignSelf: 'flex-start',
                                backgroundColor: "#F7F7F7",
                            } },
                            react_1.default.createElement(react_native_1.View, { style: {
                                    borderLeftWidth: (0, scale_1.scale)(6),
                                    borderLeftColor: "#0591E8",
                                    paddingLeft: (0, scale_1.scale)(8),
                                } },
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        fontSize: (0, scale_1.moderateScale)(16),
                                        fontWeight: "300",
                                        lineHeight: (0, scale_1.moderateScale)(24),
                                        color: "#292A33",
                                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u767B\u9332\u5B8C\u4E86")),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(15),
                                    fontWeight: "300",
                                    lineHeight: (0, scale_1.moderateScale)(23),
                                    color: "#292A33",
                                    marginTop: (0, scale_1.scale)(12),
                                } }, `アカウントの登録が完了しました。\n続いてフォローするタグを登録してください。`))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_native_1.Image, { source: images_1.images.LogoTextApp, style: {
                                    height: (0, scale_1.scale)(50),
                                    width: (0, scale_1.scale)(139),
                                    marginBottom: (0, scale_1.scale)(30),
                                } }),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    width: '100%',
                                    fontSize: (0, scale_1.moderateScale)(15),
                                    lineHeight: (0, scale_1.moderateScale)(23),
                                    color: "#292A33",
                                    fontWeight: "300",
                                } }, `新規会員登録できるメールアドレスです。\n会員登録をする場合は利用規約に同意の上、\nFujisan IDの登録を行ってください。`),
                            react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, label: "Fujisan ID (メールアドレス)", iconRightLabel: react_1.default.createElement(HelpLogin_1.default, null), onRightIconLabelPress: () => {
                                    setVisibleEmail(!visibleEmail);
                                }, value: email, display: false }),
                            react_1.default.createElement(CustomInput, { label: "パスワード", placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B", errorText: errorTexts[0], onChangeText: (val) => {
                                    refPassword.current = val;
                                } }),
                            react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginTop: (0, scale_1.scale)(8), } },
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        fontSize: (0, scale_1.moderateScale)(11),
                                        lineHeight: (0, scale_1.moderateScale)(16),
                                        color: "#545454",
                                        fontWeight: "300",
                                        textAlign: "left",
                                    } }, "\u203B"),
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        fontSize: (0, scale_1.moderateScale)(11),
                                        lineHeight: (0, scale_1.moderateScale)(16),
                                        color: "#545454",
                                        fontWeight: "300",
                                        flex: 1,
                                        textAlign: "left",
                                    } }, "10\uFF5E50\u6587\u5B57\u3067\u3001\u5927\u6587\u5B57\u82F1\u5B57\u3001\u5C0F\u6587\u5B57\u82F1\u5B57\u3001\u6570\u5B57\u3001\u8A18\u53F7\u3092\u305D\u308C\u305E\u308C\u542B\u3080\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002")),
                            react_1.default.createElement(CustomInput, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9\uFF08\u78BA\u8A8D\u7528\uFF09", placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u5165\u529B", errorText: errorTexts[1], onChangeText: (val) => {
                                    refConfirmPassword.current = val;
                                } }))),
                        react_1.default.createElement(components_1.LinearButton, { onPress: () => {
                                checkRegister ? (0, rootNavigation_1.navigate)(Routes_1.default.SELECT_TAG) : validate();
                            }, title: checkRegister ? "フォロータグの登録に進む" : "アカウントを登録", fontWeight: "600", style: styles_1.default.primaryButton, containerStyle: {
                                marginTop: (0, scale_1.scale)(32)
                            }, textStyle: styles_1.default.primaryButtonLabel }))))),
        react_1.default.createElement(ModalExplain_1.default, { visible: visibleEmail, onClose: () => {
                setVisibleEmail(false);
            }, title: "Fujisan ID\u306B\u3064\u3044\u3066", content: "\u6295\u8CC7\u306E\u5148\u8F29\u3067\u306F\u3001\u682A\u5F0F\u4F1A\u793E\u5BCC\u58EB\u5C71\u30DE\u30AC\u30B8\u30F3\u30B5\u30FC\u30D3\u30B9\u304C\u63D0\u4F9B\u3057\u3066\u3044\u308B Fujisan ID \u3092\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = RegisterScreen;
